import React, { useState, useRef, useEffect } from "react";
import AuthService from "../services/AuthService";
import { useSnackbar } from "notistack";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import AlertDialogSlide from "./GDPRDialog";
import getUserFriendlyMessages from "../genericFunctions/getUserFriendlyMessages";
import { REGISTRED } from "../genericFunctions/operationTypeConstants";

const Register = (props) => {
  const registrationKey = props.match.params.registrationKey;
  const [approvedGDPR, setGDPR] = useState(false);
  const [user, setUser] = useState({
    username: "",
    password: "",
    role: "externaluser",
    availible: true,
  });
  const [message, setMessage] = useState(null);
  let timerID = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    return () => {
      clearTimeout(timerID);
    };
  }, []);

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setUser({
      username: "",
      password: "",
      role: "externaluser",
      approvedGDPR: false,
    });
  };
  const onGDPRApproval = () => {
    setGDPR(!approvedGDPR);    
  };

  const onSubmit = (e) => {
    e.preventDefault();
    AuthService.register(user, registrationKey).then((data) => {
      const { message } = data;
      if (!message.msgError) {
        setMessage(getUserFriendlyMessages(REGISTRED, "new user"));
        resetForm();
        timerID = setTimeout(() => {
          props.history.push("/login");
        }, 1000);
      } else {
        setMessage(message);
      }
    });
  };

  useEffect(() => {
    if (message !== null) {
      enqueueSnackbar(message.msgBody, {
        variant: message.msgError ? "error" : "info",
      });
    }
    setTimeout(() => {
      setMessage(null);
    }, 3000);
  }, [message]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <form onSubmit={onSubmit}>
        <h3>Register</h3>
        <TextField
          type="text"
          name="username"
          label="Username"
          value={user.username}
          onChange={onChange}
          className="form-control"
          placeholder="Username"
          style={{ margin: "5px 0px 20px 0px", backgroundColor: "#FAFAFA" }}
          required
        />
        <TextField
          type="password"
          name="password"
          label="Password"
          value={user.password}
          onChange={onChange}
          className="form-control"
          placeholder="Password"
          style={{ margin: "5px 0px", backgroundColor: "#FAFAFA" }}
          required
        />
        <AlertDialogSlide
          onGDPRApproval={() => onGDPRApproval()}
          gDPRApproved={approvedGDPR}
          setGDPR={setGDPR}
        />
        <Button
          type="submit"
          color="primary"
          variant="contained"
          style={{ marginTop: "20px", width: "100%" }}
          disabled={!approvedGDPR}
        >
          Register
        </Button>
      </form>
    </div>
  );
};

export default Register;
